import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import './index.scss';

if (window.universalLinks) {
  // Clear history in android cordova
  window.navigator.app.clearHistory();
  // document.addEventListener(
  //   'deviceready',
  //   () => {

  //
  //   },
  //   false
  // );
  console.log('UNIVERSAL LINKS initialized');
  window.universalLinks.subscribe('open', function (eventData) {
    // do some work
    const pathname = `${eventData.path}#${eventData.hash}`;
    console.log(
      'Did launch application from the link: ' + eventData.url,
      pathname
    );
    window.location.replace(pathname);
  });

  window.universalLinks.subscribe('follow', function (eventData) {
    const getRedirectUrl = (url) => {
      const iframe = document.createElement('iframe');
      iframe.style =
        'width: 0; border: 0; height: 0; position: absolute; top: 0; right: 0; z-index: -100';
      return new Promise((resolve, reject) => {
        iframe.onload = () => {
          const iframeLocation = iframe.contentWindow.location;
          const location = {
            pathname: iframeLocation.pathname,
            hash: iframeLocation.hash,
            search: iframeLocation.search,
            host: iframeLocation.host,
          };

          resolve(location);
          iframe.remove();
        };
        iframe.src = url;
        document.body.appendChild(iframe);
      });
    };
    // do some work
    console.log('Did launch application from the link: ' + eventData.url);

    getRedirectUrl(eventData.url)
      .then((location) =>
        window.location.replace(`${location.pathname}${location.hash}`)
      )
      .catch((e) => console.warn('Failed get redirect location'));
    //window.location.href = eventData.url;
  });
}

createRoot(document.getElementById('root')).render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
